export const getFilterBackgroud = (value) => {
    const specialValues = ["#animal", "#metallic", "#transparent", "#multicolor"];
    const hexColor = specialValues.includes(value) ? null : value;
    let specialFilterSrc;

    if(!hexColor) {
        specialFilterSrc = `url(/ui/images/${value.substr(1)}.svg)`;
    }

    return (hexColor || specialFilterSrc).toLowerCase();
}

export const getSwatchStyle = (value, selected) => {
    const background = getFilterBackgroud(value);
    const swatchStyle = {
        background
    }

    if(background == "#ffffff" && !selected) {
        swatchStyle['WebkitBoxShadow'] = '1px 1px 5px -1px rgba(0,0,0,0.69)';
        swatchStyle['MozBoxShadow'] = '1px 1px 5px -1px rgba(0,0,0,0.69)';
        swatchStyle['boxShadow'] = '1px 1px 5px -1px rgba(0,0,0,0.69)';
    }

    return swatchStyle
}